import { gql } from "@apollo/client";

export const fetchBids = gql`
  query ToolsFetchBids {
    data: niaga_bid {
            organisation_id
            organisation_name
            bids {
                id
                market_day
                price_per_kg
                updated_by
            }
        }
    }
`;